export const deepFreeze = <T>(obj: T) => {
  var propNames = Object.getOwnPropertyNames(obj);
  for (let name of propNames) {
    let value = (obj as any)[name];
    if (value && typeof value === "object") {
      deepFreeze(value);
    }
  }
  Object.freeze(obj);
};

export const assignVersionToConfig = (config?: Record<string, unknown>) => {
  const rc = config?.["root-config"] || {};

  return { ...config, "root-config": { ...rc, version: process.env.BUILD } };
};

window.__sbc_config = assignVersionToConfig(window.__sbc_config);
deepFreeze(window.__sbc_config);

let importMapOverridesMerge: { imports: Record<string, string> } | undefined;

// util for testing, to ensure that the main body of getImportMapOverrides is run in each test
export const resetImportMapOverridesMerge = () => {
  importMapOverridesMerge = undefined;
};

export const getImportMapOverrides = async (scripts: HTMLScriptElement[]) => {
  if (importMapOverridesMerge) return importMapOverridesMerge;

  importMapOverridesMerge = await scripts.reduce(async (previousResultPromise, script) => {
    const previousResult = await previousResultPromise;

    if (script.hasAttribute("src")) {
      const response = await fetch(script.src);

      if (response.status === 200) {
        let result = await response.json();
        previousResult["imports"] = {
          ...previousResult["imports"],
          ...result["imports"]
        };
      }
    }

    return previousResult;
  }, Promise.resolve({ imports: {} }));

  deepFreeze(importMapOverridesMerge);

  return importMapOverridesMerge;
};

/* istanbul ignore else */
// if (!devtoolsEnabled) {
//   // There is 3 possible import-map files that we will need to merge (default, internal, dev) they are not visible on every environments.
//   // To not dupplicate the logic to understand which import-map is available on which environmnet we get the list of
//   // import-map scripts from the DOM directly. Then we'll fetch the import map files using src attribute.
//   // We merge values, and keep them in memory to not fetch again next time we'll need to access the list of import map overrides.
//   const scripts = Array.from(document.querySelectorAll(`script[type="systemjs-importmap"]`)) as HTMLScriptElement[];

//   const importMapOverrides = {
//     getCurrentPageMap: /* istanbul ignore next */ async () => getImportMapOverrides(scripts),
//     getImportMapOverrides: async () => getImportMapOverrides(scripts)
//   };

//   window.importMapOverrides = importMapOverrides;
//   deepFreeze(window.importMapOverrides);
// }
